import { Logger } from "./Logger"

declare global {
  interface Window {
    gtag?: (command: "event", name: string, params: object) => void
  }
}

// Every GA4 event the site sends. A param shows up in GA4 reports only once it is registered
// as an event-scoped custom dimension (Admin › Custom definitions), and only for later events.
type AnalyticsEvents = {
  promo_popup_view: { popup_name: string }
  promo_popup_click: { popup_name: string; link: string }
  cursor_converter_download: { source_format: string; output_format: "CUR" | "ANI" }
  cursor_constructor_view: { extension_installed: boolean }
  // Where the pack's two images came from: Sweezy assets, the visitor's own files, or one of each.
  cursor_constructor_add: { source: "library" | "upload" | "mixed" }
}

// gtag only renders in production; elsewhere the event is just logged.
export const trackAnalyticsEvent = <Name extends keyof AnalyticsEvents>(
  name: Name,
  params: AnalyticsEvents[Name],
) => {
  Logger.log("analytics event", name, params)
  window.gtag?.("event", name, params)
}
